import ListVacationBalances from './views/List.vue'
import CreateEditVacationBalance from './views/CreateEdit.vue'
import GetVacationBalance from './views/Get.vue'

export const VacationBalanceRoutes = [
  {
    path: '/vacation-balances',
    name: 'ListVacationBalance',
    component: ListVacationBalances,
    meta: {
      auth: true,
      layout: 'home',
      permission: 'vacation_balance:list'
    }
  },
  {
    path: '/vacation-balance',
    name: 'CreateVacationBalance',
    component: CreateEditVacationBalance,
    meta: {
      auth: true,
      layout: 'home',
      permission: 'vacation_balance:create'
    }
  },
  {
    path: '/vacation-balance/:id',
    name: 'UpdateVacationBalance',
    component: CreateEditVacationBalance,
    meta: {
      auth: true,
      layout: 'home',
      permission: 'vacation_balance:update'
    }
  },
  {
    path: '/vacation-balance/view/:id',
    name: 'GetVacationBalance',
    component: GetVacationBalance,
    meta: {
      auth: true,
      layout: 'home',
      permission: 'vacation_balance:get'
    }
  }
]
